import React from "react";
import { SimpleFormProvider } from "../fluidComponents/fluidForm/SimpleFormLoader";
import { FluidForm } from "../../shared";
import { ExampleAuthWrapper } from "./ExampleAuthWrapper";
const basicFormConfig = {
    "key": "review-form",
    "label": "Review Form",
    "description": "",
    // "useGoogleDrive": false,
    "strictness": "strict",
    "fields": [
        {
            key: "Personal Information",
            label: "Personal Information",
            type: "section"
        },
        {
            "key": "name",
            "label": "Name",
            "type": "fullName"
        },
        {
            "key": "email",
            "label": "Email",
            "type": "email",
            "unique": true,
        },
        {
            "key": "birthDate",
            "label": "Birth Date",
            "type": "date"
        },
        {
            key: "Preferences",
            label: "Preferences",
            type: "section",
        },
        {
            key: "favoriteMovie",
            label: "Favorite Movie",
            type: "text"
        },
        {
            key: "favoriteBook",
            label: "Favorite Book",
            type: "text"
        },
        {
            "key": "favoriteColor",
            "label": "Colors",
            "type": "multipleOptions",
            "options": [
                {
                    "text": "red",
                    "value": "Red"
                },
                {
                    "text": "blue",
                    "value": "Blue"
                }
            ],
            "fields": []
        }
    ]
};
export function ReviewComponent() {
    return (React.createElement("div", { className: "review-component" },
        React.createElement("h1", null, "Review"),
        React.createElement(ExampleAuthWrapper, { formConfig: basicFormConfig },
            React.createElement("div", { className: "review-component-content" },
                React.createElement(ClassicForm, null)))));
}
export function ClassicForm() {
    let form = new FluidForm(basicFormConfig, {
        "name": "Somebody Else",
        "email": "ricardodpsx@gmail.",
        "birthDate": "1990-08-23",
        "favoriteColor": ""
    }, {
        styleConfig: {
            style: "classic",
            inputModes: ["speech", "camera", "fileUpload", "urlCapture"]
        }
    });
    return (React.createElement("div", null,
        React.createElement(SimpleFormProvider, { form: form, submissionId: "review-submission" })));
}
